import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Asset, MultiExanteResponse, SavingsPlan, SavingsPlansOverview, TopInstruments } from '@zero/shared/util-models';
import { MultiSavingsPlanErrorResponse } from '../entities/multi-savings-plan-error.entity';
import { MultiSavingsPlan } from '../entities/multi-savings-plan.entity';
import { SavingsPlansOptionsResponse } from '../entities/options.entity';
import { SavingsPlanSubject } from '../entities/saving-plan-search.mode';
import { SavingsPlanEdit } from '../entities/savings-plan-edit.entity';

export const savingPlansActions = createActionGroup({
  source: 'Saving Plans',
  events: {
    'Load Savings Plans Overview': props<{ force: boolean }>(),
    'Cancel Savings Plan': props<{ id: string }>(),
    'Load Most Chosen Saving Plans': props<{ force: boolean; itemsCount: number }>(),
    'Load Exec Dates': props<{ force: boolean }>(),
    'Load Savings Plan Subjects': props<{ force: boolean }>(),
    'Add Asset To Form': props<{ asset: Asset }>(),
    'Remove Savings Plans From Form': props<{ savingsPlansToRemove: MultiSavingsPlan[] }>(),
    'Clear Form': emptyProps(),
    'Change Exec Date': props<{ execDate: string }>(),
    'Update Amount': props<{ savingsPlan: MultiSavingsPlan; amount: number }>(),
    'Update Amount Silently': props<{ savingsPlan: MultiSavingsPlan }>(),
    'Set Error': props<{ savingsPlan: MultiSavingsPlan; error: string }>(),
    'Add Assets to Form': props<{ savingsPlans: MultiSavingsPlan[]; totalAmount: number }>(),
    'Change Total Amount': props<{ totalAmount: number }>(),
    'Create Savings Plans': emptyProps(),
    'Load Options': emptyProps(),
    'Change Interval': props<{ interval: string }>(),
    'Load Exante': emptyProps(),
    'Revoke strategy': emptyProps(),
    'Clear Multi Savings Plan Error': emptyProps(),
    'Remove Latest Savings Plan': emptyProps(),
    'Set Savings Plan To Update': props<{ savingsPlan: SavingsPlan }>(),
    'Update Savings Plan': emptyProps(),
    'Clear Savings Plan Update Error': emptyProps(),
    'Set Dynamization': props<{ value: number }>(),
    'Load Existing Savings Plan': props<{ id: string }>(),
    'Update Existing Savings Plan Amount': props<{ amount: number }>(),
    'Set Existing Savings Plan Error': props<{ error: string; amount: number }>(),
    'Cache Onboarding Savings Plan': props<{ amount: number; isin: string }>(),
    'Clear Onboarding Savings Plan Cache': emptyProps(),
    'Clear Onboarding Savings Plan Form': emptyProps(),
    'Load Onboarding Savings Plan Infos': emptyProps(),
    'Submit Onboarding Savings Plan': emptyProps(),
    'Load Onboarding Savings Plans': emptyProps(),
    'Delete Onboarding Savings Plan': props<{ id: string }>(),
    'Clear Onboarding Savings Plan Deletion State': emptyProps(),
  },
});

export const savingPlansApiActions = createActionGroup({
  source: 'Saving Plans API',
  events: {
    'Load Savings Plans Overview From API': emptyProps(),
    'Load Savings Plans Overview Success': props<{ savingsPlansOverview: SavingsPlansOverview }>(),
    'Load Savings Plans Overview Failure': props<{ error: HttpErrorResponse }>(),
    'Cancel Savings Plan Success': emptyProps(),
    'Cancel Savings Plan Failure': props<{ error: HttpErrorResponse }>(),
    'Load Most Chosen Saving Plans From API': props<{ itemsCount: number }>(),
    'Load Most Chosen Saving Plans Success': props<{ mostChosenSavingPlans: TopInstruments }>(),
    'Load Most Chosen Saving Plans Failure': props<{ error: HttpErrorResponse }>(),
    'Load Exec Dates From API': emptyProps(),
    'Load Exec Dates Success': props<{ execDates: string[] }>(),
    'Load Exec Dates Failure': props<{ error: HttpErrorResponse }>(),
    'Load Savings Plan Subjects From API': emptyProps(),
    'Load Savings Plan Subjects Success': props<{ savingsPlanSubjects: SavingsPlanSubject[] }>(),
    'Load Savings Plan Subjects Failure': props<{ error: HttpErrorResponse }>(),
    'Add Assets to Form Success': props<{ savingsPlans: MultiSavingsPlan[] }>(),
    'Add Assets to Form Failure': props<{ error: HttpErrorResponse }>(),
    'Create Savings Plans Success': emptyProps(),
    'Create Savings Plans Failure': props<{ error: MultiSavingsPlanErrorResponse }>(),
    'Load Options Success': props<{ options: SavingsPlansOptionsResponse }>(),
    'Load Options Failure': props<{ error: HttpErrorResponse }>(),
    'Load Exante Success': props<{ multiExante: MultiExanteResponse }>(),
    'Load Exante Failure': props<{ error: HttpErrorResponse }>(),
    'Update Savings Plans Success': emptyProps(),
    'Update Savings Plans Failure': props<{ error: HttpErrorResponse }>(),
    'Load Existing Savings Plan Success': props<{ savingsPlan: SavingsPlanEdit }>(),
    'Load Existing Savings Plan Failure': props<{ error: HttpErrorResponse }>(),
    'Load Onboarding Savings Plan Infos Success': props<{ asset: Asset }>(),
    'Load Onboarding Savings Plan Infos Failure': props<{ error: HttpErrorResponse }>(),
    'Load Onboarding Savings Plan Exante Success': props<{ exante: MultiExanteResponse }>(),
    'Load Onboarding Savings Plan Exante Failure': props<{ error: HttpErrorResponse }>(),
    'Submit Onboarding Savings Plan Success': emptyProps(),
    'Submit Onboarding Savings Plan Failure': props<{ error: HttpErrorResponse }>(),
    'Load Onboarding Savings Plans Success': props<{ savingsPlans: SavingsPlan[] }>(),
    'Load Onboarding Savings Plans Failure': props<{ error: HttpErrorResponse }>(),
    'Delete Onboarding Savings Plan Success': emptyProps(),
    'Delete Onboarding Savings Plan Failure': props<{ error: HttpErrorResponse }>(),
  },
});
